import React from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'shared/components/button/Button';

/* eslint-disable react/function-component-definition */
const ConfirmationModal = ({
  confirmButtonText = 'Yes',
  cancelButtonText = 'Cancel',
  handleCloseModal,
  handleConfirm,
  handleReject,
  rejectButtonText = 'No',
  showModal,
  text,
}) => (
  <Modal size="md" show={showModal} onHide={handleCloseModal} centered>
    <Modal.Body style={{ padding: '35px' }}>
      <div className="d-flex flex-column text-center">
        <span style={{ fontWeight: 'bolder' }}>{text}</span>

        <div
          className="d-flex justify-content-center"
          style={{ marginTop: '35px' }}
        >
          <Button
            text={confirmButtonText}
            onClick={handleConfirm}
            style={{ marginRight: '15px' }}
          />
          <Button text={rejectButtonText} onClick={handleReject} />
          <Button
            text={cancelButtonText}
            defaultBtn
            onClick={handleCloseModal}
          />
        </div>
      </div>
    </Modal.Body>
  </Modal>
);

export default ConfirmationModal;
